import AppShell from "./AppShell";
import { getApp } from "@/lib/apps";

const Jadesynq = () => <AppShell app={getApp("jadesynq")} />;

export default Jadesynq;
